import api from "./api";
import type { LoginResponse, LoginResponseUser } from "../types/api";

const authService = {
  // Re-fetches the current binding + freshly-computed capabilities. Used on
  // session restore so role/team changes take effect without a re-login.
  me: async (): Promise<LoginResponseUser | null> => {
    try {
      const response = await api.get<{ success: boolean; data: LoginResponseUser }>("/api/v1/auth/me");
      return response.data.success ? response.data.data : null;
    } catch {
      return null;
    }
  },

  login: async (
    username: string,
    password: string,
    rememberMe = false
  ): Promise<LoginResponse> => {
    const response = await api.post<LoginResponse>("/api/v1/auth/login", {
      username,
      password,
      remember_me: rememberMe,
    });
    return response.data;
  },

  logout: async (): Promise<void> => {
    try {
      await api.post("/api/v1/auth/logout");
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    }
  },

  ssoExchange: async (code: string): Promise<LoginResponse> => {
    const response = await api.post<LoginResponse>("/api/v1/auth/sso-exchange", { code });
    return response.data;
  },
};

export default authService;
